import {HttpInterceptorFn} from '@angular/common/http';
import {inject} from '@angular/core';
import {catchError} from 'rxjs/operators';
import {throwError} from 'rxjs';

import {GlobalErrorHandler} from './error-handler';

export const errorHandlerInterceptor: HttpInterceptorFn = (req, next) => {
  const errorHandler = inject(GlobalErrorHandler);

  return next(req)
    .pipe(
      catchError(error => {
        if (error) {
          errorHandler.log({
            clientTime: new Date(),
            level: 'error',
            message: 'Error in request:',
            error,
          });
        }
        return throwError(() => error);
      }),
    );
};
